// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wcf8","controls":"styles_controls__3RIVj","charLimit":"styles_charLimit__3LUr5","input":"styles_input__3w5WI","send":"styles_send__3w-dQ"};